import { authApi } from '@/api/authApi'

export const authService = {
  async bootstrap() {
    return authApi.restoreSession()
  },
  async login(credentials) {
    return authApi.login(credentials)
  },
  async logout() {
    return authApi.logout()
  },
}
